import { interactionProgress } from '@/utils/interaction'
import { getPartItems, actualProgressItems } from '@/utils/items'

export default {
    interactionError: state => state.interactionError,
    instanceToken: state => state.instanceToken,
    interactionInstance: state => state.interactionInstance,
    interactionInstanceId: state => state.interactionInstanceId,
    interactionSubInstances: state => state.interactionSubInstances,
    interactionItems: state => state.interactionItems,
    currentItemNumber: state => state.currentItemNumber,
    currentItem: state => state.interactionItems && state.interactionItems.length > 0 && state.interactionItems[state.currentItemNumber],
    currentItemMetaData: state => state.currentItemMetaData,
    isLastItem: state => state.interactionItems && state.currentItemNumber === state.interactionItems.length - 1,
    outcomeTaskScenario: state => state.outcomeTaskInstance,
    outcomeTaskInstance: state => state.outcomeTaskScenario,
    outcomeTaskScenarioInstance: state => state.outcomeTaskScenarioInstance,
    interactionProgressTotal: state => interactionProgress(state.currentItemNumber, actualProgressItems(state.interactionItems).length),
    interactionProgressRelative: state => {
        const partItems = getPartItems(state.interactionItems);
        if(partItems && partItems.length > 0) {

            if(partItems.length === 1) {
                return interactionProgress(state.currentItemNumber, actualProgressItems(state.interactionItems).length);
            }
            // get current item number relative to items in part and calculate progress
            const currentPartItem = [...partItems].reverse().find(item => state.currentItemNumber > item.number)
            const currentPartItemIndex = partItems.findIndex(item => item.itemId === currentPartItem.itemId)
            const nextPartItem = partItems[currentPartItemIndex + 1]
            if(nextPartItem) {
                return interactionProgress(state.currentItemNumber - currentPartItem.number, nextPartItem.number - currentPartItem.number)
            }
            // if there's no part item at the end of interaction
            return interactionProgress(state.currentItemNumber - currentPartItem.number, actualProgressItems(state.interactionItems).length - currentPartItem.number)

        }
        // fallback: if no parts defined return overall progress
        return interactionProgress(state.currentItemNumber, actualProgressItems(state.interactionItems).length);
    },
    partItems: state => getPartItems(state.interactionItems),
    colorVariant: state => state.colorVariant,
    requestError: state => state.requestError,
    isLoading: state => state.isLoading,
    itemLoading: state => state.itemLoading,
    whitelabelConfig: state => state.interactionInstance?.whitelabelConfig
}
